import Price from "@JohnLewisPartnership/jl-design-system/dist/components/price/Price";
import classNames from "classnames/bind";
import styles from "./Price.module.scss";

const cx = classNames.bind(styles);

type Props = {
  /**
   * A string representing the brand of the product. It can also be null or undefined.
   */
  brand: string | undefined | null;
  /**
   * An object representing the price of the product. It can also be undefined. The price object can have 'was', 'then1', 'then2', and 'now' properties, each of which can be a string or an object with 'from' and 'to' properties.
   */
  price:
    | {
        was?: string | { from: string; to: string };
        then1?: string | { from: string; to: string };
        then2?: string | { from: string; to: string };
        now: string | { from: string; to: string };
      }
    | undefined;
  /**
   * A string representing a prefix to be prepended to the price.
   */
  pricePrefix?: string;
  /**
   * A string representing a suffix to be appended to the price.
   */
  priceSuffix?: string;
  /**
   * Boolean that represents if responsive styling should be used
   */
  isResponsiveStylesEnabled?: boolean;
  /**
   * Boolean that represents if the redesigned promotion pricing styling should be applied
   */
  redesignedPromoPrices?: boolean;
  /**
   * Boolean that represents if a price match promotion applies and the price has a reduction history
   */
  isPricePromiseWithHistory?: boolean;
  /**
   * Boolean that represents if a price should be highlighted for price match when no price history is established
   */
  highlightPriceMatchNonPriceEstablished?: boolean;
  /**
   * Boolean that renders the now price before the was/then prices
   */
  hasNowWasPriceEnabled?: boolean;
  /**
   * Boolean that removes the pence (.00) from whole pound prices
   */
  hasWholePoundsOnlyEnabled?: boolean;
};

export const PriceUI = ({
  brand,
  price,
  pricePrefix,
  priceSuffix,
  isResponsiveStylesEnabled,
  redesignedPromoPrices,
  isPricePromiseWithHistory,
  highlightPriceMatchNonPriceEstablished,
  hasNowWasPriceEnabled,
  hasWholePoundsOnlyEnabled,
}: Props) => {
  if (!price) {
    return null;
  }

  return (
    <Price
      brand={brand}
      price={price}
      pricePrefix={pricePrefix}
      priceSuffix={priceSuffix}
      usageContext="pdp"
      showPriceReduction={false}
      hasDiorPromosEnabled={true}
      hasNowWasPriceEnabled={hasNowWasPriceEnabled}
      hasWholePoundsOnlyEnabled={hasWholePoundsOnlyEnabled}
      className={cx({
        priceResponsive: isResponsiveStylesEnabled,
        // now-was layout supersedes the reversed was-first redesigned layout
        redesignedPromoPrices: redesignedPromoPrices && !hasNowWasPriceEnabled,
        redesignedPricePromisePrice:
          isPricePromiseWithHistory && !hasNowWasPriceEnabled,
        priceMatchedNonPriceEstablished: highlightPriceMatchNonPriceEstablished,
      })}
    />
  );
};
